import axios from "axios";


const apiUrl = process.env.REACT_APP_API_URL;

const sendInvoice = async (orderNumber: string, customerEmail: string, sendAsPdf: boolean) => {
    try {
        const response = await axios.post(`${apiUrl}/Invoice/send-invoice`, { orderNumber, customerEmail, sendAsPdf });
        return response.data;
    } catch (error: any) {
        throw new Error(`Error sending invoice: ${error.message}`);
    }
}

export default sendInvoice;